import {Splide} from '@splidejs/splide';
import { EventInterface } from '@splidejs/splide';
import Blue from "~/core";

new Blue({
  name: 'Splide Vertical',
  selector: "body",
  setup(body) {
    
    
    var shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
    if (shouldSetTimeout) {
      updateSplideMethodList({
        initSplideVertical,
        SlideTransition
      });
  
    } else {
      initSplideVertical();
    }

    var splide = document.querySelector('.splide-vertical');

    if(splide) {

      const slides = [...splide.querySelectorAll('.splide__slide')];
      slides.forEach((slide, index) => {
        var hasDialog = slide.querySelector('.splide__slide--video-trigger');
        var closeButton = slide.querySelector('.dialog-close');
        var slideDialog = slide.querySelector('dialog');
        if(hasDialog){
          hasDialog.addEventListener('click', 
            function(){
              console.log(slideDialog);
              slideDialog.showModal();
            });
            slideDialog.addEventListener('click', function(event) {
              var rect = slideDialog.getBoundingClientRect();
              var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
                rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
              if (!isInDialog) {
                slideDialog.close();
              }
            });
        }
        if(closeButton) {
          closeButton.addEventListener('click', function(){
            slideDialog.close();
          });
        }
      });
    }
  }
});

new Blue({
  name: 'Plant Details Carousel',
  selector: ".plant__dialog",
  setup(splide) {
    var shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
    var plantDetailSplide;
    if (shouldSetTimeout) {
      updateSplideMethodList({
        initPlantDetailSplide
      });
  
    } else {
        initPlantDetailSplide();
    }

    const plantImages = [...document.querySelectorAll(".plant__image")];
    const plantDialog = document.querySelector("dialog");
    const plantDialogClose = document.querySelector(".plant__dialog-close");

    if(plantDetailSplide) {

      plantImages.forEach((image) => {
        image.addEventListener("click", () => {
          plantDialog.showModal();    
          plantDetailSplide.refresh();  
          var slideNumber = image.getAttribute("data-slide-number");
          //convert to number
          slideNumber = parseInt(slideNumber);
          plantDetailSplide.go(slideNumber)
        });
      });

      plantDialogClose.addEventListener("click", () => {
        plantDialog.close();
      });
    }
  }
})

new Blue({
  name: 'Splide Carousel',
  selector: ".splide",
  setup(splide) {


    var shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
    if (shouldSetTimeout) {
      updateSplideMethodList({ 
        initSplide,
        SlideTransition
      });
  
    } else {
      initSplide();
    }

    if(splide) {
      const slides = [...splide.querySelectorAll('.splide__slide')];
      slides.forEach((slide, index) => {
        var hasDialog = slide.querySelector('.splide__slide--video-trigger');
        var closeButton = slide.querySelector('.dialog-close');
        var slideDialog = slide.querySelector('dialog');
        if(hasDialog){
          hasDialog.addEventListener('click', 
            function(){
              console.log(slideDialog);
              slideDialog.showModal();
            });
            slideDialog.addEventListener('click', function(event) {
              var rect = slideDialog.getBoundingClientRect();
              var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
                rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
              if (!isInDialog) {
                slideDialog.close();
              }
            });
        }
        if(closeButton) {
          closeButton.addEventListener('click', function(){
            slideDialog.close();
          });
        }
      });

    }
  }
});

function initPlantDetailSplide() {

  var splideElement = document.querySelector('.plant__dialog-carousel');

 if (splideElement) {

    plantDetailSplide = new Splide(splideElement, {
      autoplay: false,
      type: 'loop',
      rewind: false,
      perPage: 1,
      perMove: 1
    });
    
    plantDetailSplide.mount({}, SlideTransition);
  }
}

function initSplideVertical() {

  var element = document.querySelector('.splide-vertical');

  if(element) {

    let slider = new Splide(element, {
      pagination: false,
      autoplay: false,
      rewind: false,    
      direction: 'ttb',
      height: '14rem',
      perPage: 2,
      perMove: 2,
      classes: {
        arrows: 'splide__arrows splide__arrows--ttb scrolling-events-calendar__event-items-button-container',
        arrow : 'splide__arrow scrolling-events-calendar__event-items-button'
      },
    });

    slider.mount({}, SlideTransition);  
  }  
}

function initSplide() {
  var fractionPagination = [...document.querySelectorAll(".splide--fraction-pagination")];
  
  fractionPagination.forEach(element => {
    let slider = new Splide(element, {
      pagination: false,
      autoplay: false,
      rewind: false,
      interval: 2000,
      breakpoints: {
        767: {
          padding: { right: '0' },
        },
      }
    });
    slider.on('mounted', function () {
      element.querySelector('.splide__fraction-current').innerHTML = '1';
      let newIndexString = element.querySelectorAll('.splide__slide').length;
      element.querySelector('.splide__fraction-total').innerHTML = newIndexString;
    } );
    slider.on('move', function (newIndex) {
      let newIndexString = newIndex + 1;
      element.querySelector('.splide__fraction-current').innerHTML = newIndexString;
    } );
    slider.mount({}, SlideTransition);
  });
  
}

function SlideTransition(Splide, Components) {
  const { bind } = EventInterface(Splide);
  const { Move } = Components;
  const { list } = Components.Elements;

  let endCallback;

  function mount() {
    bind(list, 'transitionend', e => {
      if (e.target === list && endCallback) {
        // Removes the transition property
        cancel();

        // Calls the `done` callback
        endCallback();
      }
    });
  }

  function start(index, done) {
    // Converts the index to the position
    const destination = Move.toPosition(index, true);

    // Applies the CSS transition
    list.style.transition = 'transform 500ms cubic-bezier(.44,.65,.07,1.01)';

    // Moves the carousel to the destination.
    Move.translate(destination);

    // Keeps the callback to invoke later.
    endCallback = done;
  }

  function cancel() {
    list.style.transition = '';
  }

  return {
    mount,
    start,
    cancel,
  };
}

function updateSplideMethodList(functionList) {
  if(window.splideMethods)
  {
    Object.assign(window.splideMethods, functionList);
  }
  else {
    window.splideMethods = functionList;
  }
}